import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'diana-nav-icon',
    templateUrl: './nav-icon.component.html',
    styleUrls: ['./nav-icon.component.scss'],
    standalone: false
})
export class NavIconComponent {

  @Input()
  idKey!: string;

  @Input()
  textLabel?: string;

  @Input()
  iconName?: string;

  @Input()
  isDisabled?: boolean;

  @Input()
  isActive = false;

  @Input()
  hasHover = true;

  @Input()
  hasFixedWidth = true;
  
  @Input()
  isOutlined = false;
  
  @Output()
  iconClick = new EventEmitter<string>();

  constructor() { 
  }


  selectIcon(navId: string) {
    if (navId && !this.isDisabled) {
      this.iconClick.emit(navId);
    }
  }

}
